import { FormattedMessage } from 'react-intl'
import { Button } from 'src/Components'
import { PhoneSvg, LetterSvg } from 'src/svgs'
import styles from './AgentContactButton.module.scss'

export interface IAgentContactButtonProps {
  contact: string | number;
  isPhone: boolean;
}

const AgentContactButton = ({ isPhone, contact }: IAgentContactButtonProps) => (
  <Button
    href={isPhone ? `tel:${contact}` : `mailto:${contact}`}
    iconStart={isPhone ? PhoneSvg : LetterSvg}
    className={styles.contactBtn}
    data-text={contact}
    element='a'
    fullWidth
  >
    {isPhone && <FormattedMessage id='AgentCard.call' defaultMessage='Call' />}
    {!isPhone && (
      <FormattedMessage id='AgentCard.email' defaultMessage='Email' />
    )}
  </Button>
)

export default AgentContactButton
